import { Permitted } from "./aps-permitted";

export class ApsPermission {
	
	Permitted: Permitted[] = [];
	
	constructor() {
		
	}
}
